  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Um mit der Bezahlung fortzufahren, müssen Sie bitte den Allgemeinen Geschäftsbendingungen zustimmen.");
        return false;
      }
    });
  });